import { observer } from 'mobx-react-lite'
import { type Attachment } from 'entities/Attachment/model/Attachment'
import { MessagePreview } from 'widgets/MessagePreview'
import { PreviewBubble } from './PreviewBubble'
import styles from './styles.module.scss'

export type IPreviewBubblePart = {
  text: string
  isPlaceholder?: boolean
}

export type IPreviewBubble = {
  id: string
  direction: 'outbound' | 'inbound'
  parts?: IPreviewBubblePart[]
  html?: string
  attachments?: Attachment[]
}

type IPreviewProps = {
  bubbles: IPreviewBubble[]
}

export const Preview = observer(({ bubbles }: IPreviewProps) => (
  <MessagePreview
    customContent={
      <div className={styles.wrap}>
        {bubbles.map((bubble) => (
          <PreviewBubble key={bubble.id} bubble={bubble} />
        ))}
      </div>
    }
  />
))
